import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../../../group_leader/components/common'
import PlayerRow from '../../common/PlayerRow'
import { makeT } from '../../../../group_leader/helpers/i18n'
import { playerFullName, playerInitials } from '../../../../group_leader/helpers/player'

const t = makeT('group_leader.event_setup.pairings')

// Golfers not yet on the sheet; each row is a drag source with no group (`foursomeId: null`).
const PairingsBench = ({ players, onPlace, busy, dnd }) => (
        <div className="gl-event-setup-unplaced-panel">
          <div className="gl-event-setup-unplaced-hd">
            <span className="gl-event-setup-unplaced-title">
              {t('not_on_tee_sheet.title', { count: players.length })}
            </span>
          </div>
          {players.map((player) => {
            const pid = player.player_round_id || player.id
            return (
              <div
                key={pid}
                className={`gl-event-setup-unplaced-item${dnd.isBeingDragged(pid) ? ' is-dragging' : ''}`}
                draggable
                onDragStart={(event) => dnd.startPlayerDrag(event, {
                  source: { foursomeId: null, playerRoundId: pid },
                  name: playerFullName(player),
                  initials: playerInitials(player),
                  handicapIndex: player.handicap_index,
                })}
                onDragEnd={() => dnd.clearPlayerDrag()}
              >
                <PlayerRow player={player}/>
                <Button
                  variant="secondary"
                  size="sm"
                  ariaLabel={t('sheet.auto_assign_aria')}
                  onClick={() => onPlace(player)}
                  disabled={busy}
                >
                  &#8594;
                </Button>
              </div>
            )
          })}
        </div>
)

PairingsBench.propTypes = {
  players: PropTypes.array.isRequired,
  onPlace: PropTypes.func.isRequired,
  // True while a placement write is in flight, so a second click cannot double-seat anyone.
  busy: PropTypes.bool,
  // usePairingsDnD's handle. The drag state is shared with the tee sheet, which is the drop target.
  dnd: PropTypes.shape({
    isBeingDragged: PropTypes.func.isRequired,
    startPlayerDrag: PropTypes.func.isRequired,
    clearPlayerDrag: PropTypes.func.isRequired,
  }).isRequired,
}

export default PairingsBench
